// extracted by mini-css-extract-plugin
module.exports = {"v_cornerRadiusSm":"20px","v_cornerRadiusMd":"20px"};